import React from 'react';
import { Lozenge } from '../../../CommonComponents/OPL/Lozenge/Lozenge';
import { HeldAwayInstitutionStatus } from '../../api/useDataReconciliationQuery';

interface Props {
  status: HeldAwayInstitutionStatus;
}

export const DataReconciliationTableStatus: React.FC<Props> = ({ status }) => {
  if (status === HeldAwayInstitutionStatus.Good) {
    return <Lozenge variantColor="success">Active</Lozenge>;
  }

  if (status === HeldAwayInstitutionStatus.Broken) {
    return (
      <Lozenge variantColor="warning" icon="fas fa-exclamation-triangle">
        Fix Connection
      </Lozenge>
    );
  }

  return <Lozenge>Pending</Lozenge>;
};
